import { primitiveTypes } from '../types.js';
export var SchemaErrorCode;
(function (SchemaErrorCode) {
    SchemaErrorCode[SchemaErrorCode["INVALID_EXTERNAL_TYPE"] = 0] = "INVALID_EXTERNAL_TYPE";
    SchemaErrorCode[SchemaErrorCode["INVALID_EXTERNAL_DEFAULT_TYPE"] = 1] = "INVALID_EXTERNAL_DEFAULT_TYPE";
    SchemaErrorCode[SchemaErrorCode["INVALID_EXTERNAL_PROPERTY_PATH"] = 2] = "INVALID_EXTERNAL_PROPERTY_PATH";
    SchemaErrorCode[SchemaErrorCode["INVALID_EXTERNAL_FIELD"] = 3] = "INVALID_EXTERNAL_FIELD";
    SchemaErrorCode[SchemaErrorCode["INVALID_RESOLUTION_SCHEMA"] = 4] = "INVALID_RESOLUTION_SCHEMA";
})(SchemaErrorCode || (SchemaErrorCode = {}));
export class SchemaError extends Error {
    constructor(code, message = 'SchemaError') {
        super(message);
        this.code = code;
    }
    static invalidExternalType(external, context) {
        return new SchemaError(SchemaErrorCode.INVALID_EXTERNAL_TYPE, `Invalid external type "${external.type}" in "${context}". Should be a primitive type: ${primitiveTypes}.`);
    }
    static invalidExternalDefaultType(external, context) {
        return new SchemaError(SchemaErrorCode.INVALID_EXTERNAL_DEFAULT_TYPE, `Invalid external default value "${JSON.stringify(external.default)}" in "${context}". Expected value of ${external.type} type`);
    }
    static invalidExternalPropertyPath(path, context) {
        return new SchemaError(SchemaErrorCode.INVALID_EXTERNAL_PROPERTY_PATH, `Invalid external property name(path) "${path}" in ${context}`);
    }
    static invalidExternalFieldData(doc, context) {
        return new SchemaError(SchemaErrorCode.INVALID_EXTERNAL_FIELD, `Invalid external field "${doc.name}". ${context}`);
    }
    static invalidResolutionSchemaProductsDefinition() {
        return new SchemaError(SchemaErrorCode.INVALID_RESOLUTION_SCHEMA, `Invalid products field. Must be an array`);
    }
    static productResolutionSchemaTypedMissed(index) {
        return new SchemaError(SchemaErrorCode.INVALID_RESOLUTION_SCHEMA, `Type is missed in Product Resolution Schema definition at ${index} position`);
    }
    static invalidTypeInProductResolutionSchema(type, index) {
        return new SchemaError(SchemaErrorCode.INVALID_RESOLUTION_SCHEMA, `Unregistered type in Product Resolution Schema definition at ${index} position`);
    }
}
//# sourceMappingURL=SchemaError.js.map